import { gql } from '@apollo/client'
import { CHATBOT_SETTINGS_FIELDS } from './fragments/chatbot_settings'

export const UPDATE_CHATBOT_SETTINGS = gql`
  ${CHATBOT_SETTINGS_FIELDS}
  mutation updateChatbotSettings(
    $appNotificationsEnabled: Boolean
    $communicationStyle: ChatbotSettingsCommunicationStyle
    $dataSharingEnabled: Boolean
    $emailNotificationsEnabled: Boolean
  ) {
    updateChatbotSettings(
      appNotificationsEnabled: $appNotificationsEnabled
      communicationStyle: $communicationStyle
      dataSharingEnabled: $dataSharingEnabled
      emailNotificationsEnabled: $emailNotificationsEnabled
    ) {
      ...ChatbotSettingsFields
    }
  }
`
